export function getMyDate (...args) {
  return new Date(...args)
}
